import React, {Component} from 'react';
import './Tabs.css';
import {Link, matchPath} from 'react-router-dom';
import {connect} from 'react-redux';

class Tabs extends Component {
	tabSelected(item) {
		if (item.current === false) {
			return '';
		} else if (matchPath(this.props.path, {path: item.link}) || item.current) {
			return 'Tabs-selected';
		}
		return '';
	}

	render() {
		const items = this.props.items;

		return (
			<nav className="Tabs">
				{items &&
					items
						.filter(item => !!item)
						.map(item => (
							<Link
								key={item.key || item.link}
								to={item.link}
								onClick={item.onClick}
								className={this.tabSelected(item)}>
								<span className={`icon ${item.icon}`} />
								<span>{item.label}</span>
								{item.children}
								{item.badgeCount && item.badgeCount !== 0 ? (
									<span className="Tabs-badge" title={item.badgeTitle}>
										{item.badgeCount}
									</span>
								) : null}
							</Link>
						))}
			</nav>
		);
	}
}

const ConnectedTabs = connect(state => ({
	path: state.router.location.pathname
}))(Tabs);

export default ConnectedTabs;



// WEBPACK FOOTER //
// ./src/widgets/Tabs.js